import PropTypes from "prop-types";
import { classNamePropType, statusPropType } from "../../common";

/**
 * PropTypes for Status component
 *
 * @property {('active'|'inactive'|'pending'|'success'|'error'|'warning'|'completed')} status - Status value (required)
 * @property {string} [label] - Optional text label to display with status indicator
 * @property {string} [className] - Additional CSS classes
 * @property {('dot'|'badge'|'pill')} [variant] - Visual variant style
 */
export const statusPropTypes = {
  status: statusPropType.isRequired,
  label: PropTypes.string,
  className: classNamePropType,
  variant: PropTypes.oneOf(["dot", "badge", "pill"]),
};
